import React, { ReactNode } from 'react';

export const PageBox = ({ children }: { children: ReactNode }) => {
  return <div className="flex min-h-screen flex-col overflow-y-auto">{children}</div>;
};
